"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mk_pair = void 0;
var mk_pair = function (a, b) { return ([a, b]); };
exports.mk_pair = mk_pair;
